export default "__VITE_ASSET__rN8$_93r__"